import React from 'react';
import { Link } from 'react-router';
import { IconWrap } from './IconWrap';
import { CiLock } from 'react-icons/ci';
import useTheme from '../hooks/useTheme';

export const Footer: React.FC = () => {
  const { theme } = useTheme();
  const quickLinks = [
    { path: '/about', label: 'About BCBH' },
    { path: '/partners', label: 'Partners' },
    { path: '/events', label: 'Events & Missions' },
    { path: '/news', label: 'News' },
    { path: '/membership', label: 'Membership' },
    { path: '/contact', label: 'Contact' },
  ];

  const comingSoonLinks = [
    { label: 'Tenders Portal', path: '#' },
    { label: 'Opportunities Exchange', path: '#' },
    { label: 'Member Directory', path: '#' },
    { label: 'Reports', path: '#' },
  ];

  return (
    <footer
      style={{
        backgroundColor: theme.background.panel,
        borderTop: `1px solid ${theme.colors.line}`,
        paddingTop: '48px',
        paddingBottom: '24px',
      }}
    >
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          padding: '0 20px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '48px',
            marginBottom: '40px',
          }}
          className="footerGrid"
        >
          <div>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: theme.text.primary,
                marginBottom: '12px',
              }}
            >
              BCBH
            </h3>
            <p
              style={{
                color: theme.text.muted,
                fontSize: '14px',
                lineHeight: 1.6,
                marginBottom: '8px',
              }}
            >
              A Korea–Egypt bridge for knowledge exchange, partnerships, and project opportunities.
            </p>
            <p
              style={{
                color: theme.text.muted,
                fontSize: '14px',
                lineHeight: 1.6,
              }}
            >
              Launched by BTEC, LOHMANN ECCE, and BTP.
            </p>
          </div>

          <div>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: theme.text.primary,
                marginBottom: '12px',
              }}
            >
              Quick Links
            </h3>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  style={{
                    color: theme.text.muted,
                    textDecoration: 'none',
                    fontSize: '14px',
                    transition: 'color 0.2s ease',
                  }}
                  className="footerLink"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: 600,
                color: theme.text.primary,
                marginBottom: '12px',
              }}
            >
              Offices
            </h3>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                color: theme.text.muted,
                fontSize: '14px',
                lineHeight: 1.6,
              }}
            >
              <div>
                <div style={{ fontWeight: 500, color: theme.text.primary, marginBottom: '4px' }}>
                  Cairo Office
                </div>
                <div>BCBH office at LOHMANN ECCE</div>
              </div>
              <div>
                <div style={{ fontWeight: 500, color: theme.text.primary, marginBottom: '4px' }}>
                  Busan Office
                </div>
                <div>BTEC chairman's company + BTP facility support</div>
              </div>
              <div style={{ marginTop: '8px' }}>
                <div style={{ fontWeight: 500, color: theme.text.primary, marginBottom: '4px' }}>
                  Email
                </div>
                <div>info@korea-egypt.com</div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            borderTop: `1px solid ${theme.colors.line}`,
            paddingTop: '24px',
            marginBottom: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px',
              marginBottom: '16px',
            }}
          >
            {comingSoonLinks.map((link) => (
              <span
                key={link.label}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  color: theme.text.muted,
                  fontSize: '13px',
                  opacity: 0.7,
                }}
              >
                <IconWrap icon={<CiLock />} size={14} color="muted" />
                {link.label}
              </span>
            ))}
          </div>
        </div>

        <div
          style={{
            borderTop: `1px solid ${theme.colors.line}`,
            paddingTop: '20px',
            textAlign: 'center',
            color: theme.text.muted,
            fontSize: '13px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <div>© 2025 LOHMANN ECCE — BUSAN–CAIRO BUSINESS HUB (BCBH).</div>
          <div style={{ fontSize: '11px', opacity: 0.8 }}>
            Phase 1 launch site • Phase 2/3 portal modules in preparation.
          </div>
        </div>
      </div>
    </footer>
  );
};

